import { frontendURL } from '../../../../helper/URLHelper';
import store from 'dashboard/store';

const legacyRouteNames = {
  general_settings_billing: 'legacy_general_settings_billing',
  general_settings_billing_usage: 'legacy_general_settings_billing_usage',
  general_settings_ai_credits: 'legacy_general_settings_ai_credits',
  general_settings_billing_plans: 'legacy_general_settings_billing_plans',
  general_settings_whatsapp_fees: 'legacy_general_settings_whatsapp_fees',
  general_settings_ai_billing: 'legacy_general_settings_ai_billing',
};

const compatibleBillingRedirect = (to, routeName) => {
  const account = store.getters.getUserAccounts?.find(
    item => item.id === Number(to.params.accountId)
  );

  return account?.organization_id
    ? {
        name: routeName,
        params: { organizationId: account.organization_id },
        query: to.query,
        hash: to.hash,
      }
    : {
        name: legacyRouteNames[routeName],
        params: { accountId: to.params.accountId },
        query: to.query,
        hash: to.hash,
      };
};

const generalSettingsBillingRedirects = {
  billing: 'general_settings_billing',
  'billing/usage': 'general_settings_billing_usage',
  'billing/ai-credits': 'general_settings_ai_credits',
  'billing/plans': 'general_settings_billing_plans',
  'whatsapp-fees': 'general_settings_whatsapp_fees',
  'ai-billing': 'general_settings_ai_billing',
};

const settingsBillingRedirects = {
  '': 'general_settings_billing',
  usage: 'general_settings_billing_usage',
  'ai-credits': 'general_settings_ai_credits',
  plans: 'general_settings_billing_plans',
  'whatsapp-fees': 'general_settings_whatsapp_fees',
  'ai-billing': 'general_settings_ai_billing',
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/general'),
      redirect: to => ({
        name: 'general_info_index',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: frontendURL('accounts/:accountId/settings/general/admin'),
      redirect: to => ({
        name: 'general_info_index',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: frontendURL('accounts/:accountId/settings/general/security'),
      redirect: to => ({
        name: 'general_info_index',
        params: { accountId: to.params.accountId },
      }),
    },
    ...Object.entries(generalSettingsBillingRedirects).map(
      ([legacyPath, routeName]) => ({
        path: frontendURL(`accounts/:accountId/settings/general/${legacyPath}`),
        redirect: to => compatibleBillingRedirect(to, routeName),
      })
    ),
    ...Object.entries(settingsBillingRedirects).map(([subpath, routeName]) => ({
      path: frontendURL(
        `accounts/:accountId/settings/billing${subpath ? `/${subpath}` : ''}`
      ),
      redirect: to => compatibleBillingRedirect(to, routeName),
    })),
  ],
};
